import { Component, inject, OnDestroy, OnInit } from '@angular/core'
import PostData from '../../../../public/data/posts.json'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'
import { Subscription } from 'rxjs'
import { slugify, isUUID } from '../../utils/string-helper'
import { PostCardComponent } from '../../components/post-card-component/post-card-component'
import { CommonModule } from '@angular/common'
import { PostContent } from '../../models/post-content'
import { convertPostContent } from '../../utils/post-helper'
import { PostContentSection } from '../../sections/post-content-section/post-content-section'
import { Meta, Title } from '@angular/platform-browser'
import { environment } from '../../../environments/environment'
import { getDefaultRoute, getNotFoundRoute } from '../../utils/route-helper'

@Component({
  selector: 'app-post',
  standalone: true,
  imports: [PostCardComponent, CommonModule, PostContentSection, RouterModule],
  templateUrl: './post.html',
  styleUrl: './post.sass',
})
export class Post implements OnInit, OnDestroy {
  protected post?: PostContent
  protected hasEmbed = false
  protected config = environment

  protected get coverUrl(): string {
    const image = this.post?.cover?.image
    return image?.file?.url || image?.external?.url || ''
  }

  private slugParam: string | null = null

  private router = inject(Router)
  private route = inject(ActivatedRoute)
  private paramMapSubscription: Subscription | undefined
  private meta = inject(Meta)
  private title = inject(Title)

  ngOnInit(): void {
    this.paramMapSubscription = this.route.paramMap.subscribe((params) => {
      this.slugParam = params.get('slug')

      if (!this.slugParam) {
        this.router.navigateByUrl(getDefaultRoute(this.config))
        return
      }

      let pData
      if (isUUID(this.slugParam)) pData = (PostData as any[]).find((p) => p.id.replaceAll('-', '') === this.slugParam)
      else
        pData = (PostData as any[]).find(
          (p) => slugify(p?.properties?.Name?.title?.[0]?.text?.content) === this.slugParam,
        )

      if (!pData) {
        this.router.navigateByUrl(getNotFoundRoute())
        return
      }

      this.post = convertPostContent(pData)
      this.hasEmbed = this.post?.content?.some((c: any) => c.type === 'embed') || false

      this.initTitle()
      this.initMetaTags()
    })
  }

  ngOnDestroy(): void {
    if (this.paramMapSubscription) this.paramMapSubscription.unsubscribe()
  }

  private initTitle() {
    this.title.setTitle((this.post?.title || this.title.getTitle() || '') + ' | ' + this.config.prefixOGTitle)
  }

  private initMetaTags() {
    this.updateOGTitle()
    this.updateOGImage()
  }

  private updateOGTitle() {
    this.meta.updateTag({
      name: 'og:title',
      content:
        (this.post?.title.trim() || this.meta.getTag('name="og:title"')?.content.trim() || '') +
        ' | ' +
        this.config.prefixOGTitle,
    })
  }

  private updateOGImage() {
    this.meta.updateTag({
      name: 'og:image',
      content: `${this.post?.cover?.image?.file?.url}` || this.meta.getTag('name="og:image"')?.content || '',
    })
  }
}
